import React from 'react';
import map from 'lodash/map';
import join from 'lodash/join';
import {
  Table,
  ResultsHoverTableRow,
  TableData,
  ResultsData,
  ResultsHeaderRow,
  ResultsHeader,
} from 'components/styled-components';
import { Icon, NonIdealState } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { iconPicker } from 'utils/functions';
import styled from 'styled-components';
import colors from 'utils/colors';
import { withRouter } from 'react-router';
import { FlexRow } from '../styled-components';
import hasPermission from 'utils/hasPermission';
import permissions from 'utils/permissions';
import { shouldBold } from 'utils/functions';
import shortid from 'shortid';

const TableRow = ({ request, push, appUser, query }) => {
  const icon = iconPicker(request.statusCategory);
  return (
    <ResultsHoverTableRow
      onClick={() => push(`/assessments/${request.vendorRequestID}`)}
    >
      <TableDataWithHeaders>{request.vendorRequestID}</TableDataWithHeaders>
      <TableDataWithHeaders color={colors.primary}>
        {request.vendorInformation
          ? shouldBold(request.vendorInformation.vendorName, query)
          : 'N/A'}
      </TableDataWithHeaders>
      <TableDataWithHeaders>
        {shouldBold(request.productServiceName, query)}
      </TableDataWithHeaders>
      <TableDataWithHeaders>
        {request.requestSubmittedDate}
      </TableDataWithHeaders>
      {hasPermission(appUser.permissions, [
        permissions.MODIFY_ALL_THIRD_PARTY_REQUESTS,
        permissions.MODIFY_OWNED_THIRD_PARTY_REQUESTS,
      ]) && (
        <TableDataWithHeaders style={{ whiteSpace: 'nowrap' }}>
          <Icon icon={icon.icon} intent={icon.intent} />{' '}
          {shouldBold(request.requestStatus, query)}
        </TableDataWithHeaders>
      )}
      <TableDataWithHeaders>
        {join(request.departmentsRequesting, ', ')}
      </TableDataWithHeaders>
      <TableDataWithHeaders>
        {request.reqPoInvoice ? request.reqPoInvoice : 'N/A'}
      </TableDataWithHeaders>
      <TableDataWithHeaders>
        {request.questionnaireCompletionDate}
      </TableDataWithHeaders>
      {hasPermission(appUser.permissions, [
         permissions.VIEW_REQUEST_APPROVAL
      ]) && (
        <TableDataWithHeaders>{request.approvalDate}</TableDataWithHeaders>
      )}
      {hasPermission(appUser.permissions, [
        permissions.VIEW_REQUEST_APPROVAL
      ]) && (
        <TableDataWithHeaders>{request.renewalDate}</TableDataWithHeaders>
      )}
      <TableDataWithHeaders>
        {shouldBold(request.sponsorInformation.lastName, query)},{' '}
        {shouldBold(request.sponsorInformation.firstName, query)}
      </TableDataWithHeaders>
      {hasPermission(appUser.permissions, [
         permissions.VIEW_REQUEST_APPROVAL
      ]) && (
        <TableDataWithHeaders>
          {request.overrideNote ? request.overrideNote : 'N/A'}
        </TableDataWithHeaders>
      )}
    </ResultsHoverTableRow>
  );
};

const RequestsTable = ({
  totalCount,
  requests,
  history,
  handleOrderByClick,
  orderBy,
  orderDesc,
  isError,
  query,
  appUser,
}) => {
  if (totalCount === 0) {
    return (
      <FlexRow justify="center" padding="2rem">
        <NonIdealState
          icon="info-sign"
          title="No Third Party assessments found"
          description={
            <>
              The system did not find any Third Party assessments. <br /> Try
              creating a new one.
            </>
          }
        />
      </FlexRow>
    );
  } else {
  }
  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <Table>
        <tbody>
          <ResultsHeaderRow>
            <ResultsHeader
              style={{ whiteSpace: 'nowrap' }}
              onClick={() => handleOrderByClick('vendorRequestID')}
            >
              Assessment ID{' '}
              <StyledIcon
                icon={
                  orderBy === 'vendorRequestID' && !orderDesc
                    ? IconNames.SORT_DESC
                    : IconNames.SORT_ASC
                }
                color={colors.gray}
              />
            </ResultsHeader>
            <ResultsHeader
              style={{ whiteSpace: 'nowrap' }}
              onClick={() => handleOrderByClick('vendorName')}
            >
              Third Party Name{' '}
              <StyledIcon
                icon={
                  orderBy === 'vendorName' && !orderDesc
                    ? IconNames.SORT_DESC
                    : IconNames.SORT_ASC
                }
                color={colors.gray}
              />
            </ResultsHeader>
            <ResultsHeader
              style={{ whiteSpace: 'nowrap' }}
              onClick={() => handleOrderByClick('productServiceName')}
            >
              Product / Service
              <StyledIcon
                icon={
                  orderBy === 'productServiceName' && !orderDesc
                    ? IconNames.SORT_DESC
                    : IconNames.SORT_ASC
                }
                color={colors.gray}
              />
            </ResultsHeader>
            <ResultsHeader
              style={{ whiteSpace: 'nowrap' }}
              onClick={() => handleOrderByClick('requestSubmittedDate')}
            >
              Assessment Created Date{' '}
              <StyledIcon
                icon={
                  orderBy === 'requestSubmittedDate' && !orderDesc
                    ? IconNames.SORT_DESC
                    : IconNames.SORT_ASC
                }
                color={colors.gray}
              />
            </ResultsHeader>
            {hasPermission(appUser.permissions, [
              permissions.MODIFY_ALL_THIRD_PARTY_REQUESTS,
              permissions.MODIFY_OWNED_THIRD_PARTY_REQUESTS,
            ]) && (
              <ResultsHeader
                style={{ whiteSpace: 'nowrap' }}
                onClick={() => handleOrderByClick('requestStatus')}
              >
                Assessment Status{' '}
                <StyledIcon
                  icon={
                    orderBy === 'requestStatus' && !orderDesc
                      ? IconNames.SORT_DESC
                      : IconNames.SORT_ASC
                  }
                  color={colors.gray}
                />
              </ResultsHeader>
            )}
            <ResultsHeader
              style={{ whiteSpace: 'nowrap' }}
              onClick={() => handleOrderByClick('departmentsRequesting')}
            >
              Requesting Departments{' '}
              <StyledIcon
                icon={
                  orderBy === 'departmentsRequesting' && !orderDesc
                    ? IconNames.SORT_DESC
                    : IconNames.SORT_ASC
                }
                color={colors.gray}
              />
            </ResultsHeader>
            <ResultsHeader
              style={{ whiteSpace: 'nowrap' }}
              onClick={() => handleOrderByClick('reqPoInvoice')}
            >
              Req / PO / Invoice{' '}
              <StyledIcon
                icon={
                  orderBy === 'reqPoInvoice' && !orderDesc
                    ? IconNames.SORT_DESC
                    : IconNames.SORT_ASC
                }
                color={colors.gray}
              />
            </ResultsHeader>
            <ResultsHeader
              style={{ whiteSpace: 'nowrap' }}
              onClick={() => handleOrderByClick('questionnaireCompletionDate')}
            >
              Date Submitted{' '}
              <StyledIcon
                icon={
                  orderBy === 'questionnaireCompletionDate' && !orderDesc
                    ? IconNames.SORT_DESC
                    : IconNames.SORT_ASC
                }
                color={colors.gray}
              />
            </ResultsHeader>
            {hasPermission(appUser.permissions, [
              permissions.VIEW_REQUEST_APPROVAL,
            ]) && (
              <ResultsHeader
                style={{ whiteSpace: 'nowrap' }}
                onClick={() => handleOrderByClick('approvalDate')}
              >
                Date Approved{' '}
                <StyledIcon
                  icon={
                    orderBy === 'approvalDate' && !orderDesc
                      ? IconNames.SORT_DESC
                      : IconNames.SORT_ASC
                  }
                  color={colors.gray}
                />
              </ResultsHeader>
            )}
            {hasPermission(appUser.permissions, [
             permissions.VIEW_REQUEST_APPROVAL,
            ]) && (
              <ResultsHeader
                style={{ whiteSpace: 'nowrap' }}
                onClick={() => handleOrderByClick('renewalDate')}
              >
                Renewal Date{' '}
                <StyledIcon
                  icon={
                    orderBy === 'renewalDate' && !orderDesc
                      ? IconNames.SORT_DESC
                      : IconNames.SORT_ASC
                  }
                  color={colors.gray}
                />
              </ResultsHeader>
            )}
            <ResultsHeader
              style={{ whiteSpace: 'nowrap' }}
              onClick={() => handleOrderByClick('sponsorLastName')}
            >
              Sponsor Name{' '}
              <StyledIcon
                icon={
                  orderBy === 'sponsorLastName' && !orderDesc
                    ? IconNames.SORT_DESC
                    : IconNames.SORT_ASC
                }
                color={colors.gray}
              />
            </ResultsHeader>
            {hasPermission(appUser.permissions, [
              permissions.VIEW_REQUEST_APPROVAL
            ]) && (
              <ResultsHeader style={{ whiteSpace: 'nowrap' }}>
                Conditional Approval Comment
              </ResultsHeader>
            )}
          </ResultsHeaderRow>
          {isError || requests.length < 1 ? (
            <tr>
              <TableData colSpan={12}>
                <NonIdealState
                  icon={query === '' ? 'error' : 'search'}
                  title="No Assessments were found."
                  description={
                    query === ''
                      ? 'Try Creating a new assessment'
                      : 'Your search did not match any assessments'
                  }
                />
              </TableData>
            </tr>
          ) : (
            map(requests, request => (
              <TableRow
                key={shortid.generate()}
                request={request}
                push={history.push}
                appUser={appUser}
                query={query}
              />
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

const TableDataWithHeaders = styled(ResultsData)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    /*
	Label the data
	*/
    &:nth-of-type(1):before {
      content: 'Assessment ID';
    }
    &:nth-of-type(2):before {
      content: 'Third Party Name';
      color: ${colors.gray};
    }
    &:nth-of-type(3):before {
      content: 'Product / Service';
    }
    &:nth-of-type(4):before {
      content: 'Assessment Created Date';
    }
    &:nth-of-type(5):before {
      content: 'Assessment Status';
    }
    &:nth-of-type(6):before {
      content: 'Requesting Departments';
    }
    &:nth-of-type(7):before {
      content: 'Req / PO / Invoice';
    }
    &:nth-of-type(8):before {
      content: 'Date Submitted';
    }
    &:nth-of-type(9):before {
      content: 'Date Approved';
    }
    &:nth-of-type(10):before {
      content: 'Renewal Date';
    }
    &:nth-of-type(11):before {
      content: 'Sponsor Name';
    }
    &:nth-of-type(12):before {
      content: 'Conditional Approval Comment';
    }
  }
`;

const StyledIcon = styled(Icon)`
  transition: all 0.3s ease;
  opacity: 0;
  margin-left: 1rem;
  ${ResultsHeader}:hover & {
    opacity: 1;
  }
`;

export default withRouter(RequestsTable);
